module.exports = __webpack_public_path__ + "img/IMG_7267.66a5a58d.jpg";